
import { AxiosTeenus } from './axios-teenus';
import { AuthenticatedUser } from '@/models/AuthenticatedUser';

export class KasutajaTeenus {

    public async kasutajaInfo(): Promise<AuthenticatedUser> {

        const axios = new AxiosTeenus();

        const response = await axios
            .get<AuthenticatedUser>(`/api/kasutaja/info`);

        return response?.data;
    }

    public async kasutajaUmberlaadimine(): Promise<AuthenticatedUser> {
        const axios = new AxiosTeenus();

        const response = await axios
            .get<AuthenticatedUser>(`/api/kasutaja/kasutajaumberlaadimine`);

        return response?.data;
    }
}